import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';

const EmployeeList: React.FC = () => {

    // Specify the options of this list:
    const objectName = 'employee.general.object_name'
    const query = {
        endpoint: 'get_employee_list',
        defaultParams: { 'is_active': true },
        object: 'employee'
    }
    const showSearch = true

    // Specify detail page for this list
    const onRowClick = 'detailPage'
    const detailPageUrl = 'employees'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '7fr', field: 'full_name', label: 'employee.general.full_name_label' },
        { width: '5fr', field: 'number', label: 'employee.general.number_label' },
        { width: '5fr', field: 'role_name', label: 'employee.general.role_name_label' },
        { width: '5fr', field: 'date_of_employment', label: 'employee.general.date_of_employment_label' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'employee.general.active_employees_label',
            params: { 'is_active': true },
            default: true,
        },
        {
            group: 'general.archive',
            filters: [
                {
                    id: 'inactive',
                    label: 'employee.general.inactive_employees_label',
                    shortName: 'general.deactivated',
                    params: { 'is_active': false },
                }
            ]
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
        />
    );
};

export default EmployeeList;
